
<wiz-vgroup width="100%" height="100%" padding="0px" style="overflow: auto !important;">
  <wiz-hgroup #hgDetailZone [visible]="showFilters" 
  width="100%" style="flex-flow: row wrap; overflow: auto">
    <ng-container #containerFilter ></ng-container>
  </wiz-hgroup>
</wiz-vgroup>
